 import axios from 'axios'

 const instance = axios.create(
  {  baseURL: "https://vidly-backend-hn1a.onrender.com/"}
 )

 export default instance
